<template>
  <div class="app-footer__contact">
    <div class="app-footer__title">
      Wir sind für dich da
    </div>
    <div class="icon-row">
      <div>
        <FontAwesomeIcon :icon="faPhone"/>
      </div>
      <div>
        <a href="tel:+49410299740" target="_blank">04102 9974-0</a>
      </div>
    </div>
    <div class="icon-row">
      <div>
        <FontAwesomeIcon :icon="faPaperPlane"/>
      </div>
      <div>
        <a href="mailto:info@stadtwerke-ahrensburg.de" target="_blank">info@stadtwerke-ahrensburg.de</a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faPhone,
  faFax,
  faPaperPlane,
} from '@fortawesome/pro-solid-svg-icons';

library.add(faPhone, faFax, faPaperPlane);
</script>
